import React from 'react';
import styled from 'styled-components';
import CourtBooking from '../../../components/CourtBooking';

const Box = styled.div`
  margin-top: 0.75rem;
`;

export default function HelpCourtBookingPanel() {
  return (
    <Box>
      <CourtBooking />
    </Box>
  );
}
